export const USER_FIELDS = `
  fragment userFields on User {
    _id
    mobile
    email
    firstName
    lastName
    firebaseToken
    language
    photo
    roles
  }
`;

export const GET_ME = `
  ${USER_FIELDS}
  query {
    me {
      user {
        ...userFields
      }
    }
  }
`;

export const GET_USERS = `
  ${USER_FIELDS}
  query ($userIds: [String]) {
    getUsersFull(userIds: $userIds) {
      ...userFields
    }
  }
`;

export const REGISTER_USER = `
mutation ($user: UserInput) {
    registerUserAdmin(user: $user) {
      _id
    }
  }
`;

export const EDIT_USER = `
  mutation ($userId: String, $user: UserInput) {
    editUser(userId: $userId, user: $user) {
      _id
    }
  }
`;

export const RESOLVE_USER_IDS_FIELDS = `
  fragment resolveUserIdsFields on ResolveUserIds {
    _id
     firstName
    lastName
    mobile
    photo
    lastSeen
    contactInfo {
      phones
      email
    }
  }
`;

export const PERSON_RESOLVED_FIELDS = `
  fragment personResolvedFields on PersonResolved {
    _id
    firstName
    lastName
    mobile
    photo
  }
`;

export const GET_RESOLVE_USERS = `
  ${RESOLVE_USER_IDS_FIELDS}
  query getResolveUsersByIds($ids: [String]) {
    resolveUserIds(ids: $ids) {
      ...resolveUserIdsFields
    }
  }
`;

export const SEARCH_USER_WITH_MOBILE = `
 ${USER_FIELDS}
  query SearchUserWithMobile($mobile: String!) {
    searchUserWithMobile(mobile: $mobile) { 
      ...userFields
    }
  } 
`;
